module.exports = __webpack_public_path__ + "static/img/jigou-1-top.0b51575.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou-1-top.png
// module id = l0tW
// module chunks = 2